import React from "react";
import { Navigate } from "react-router-dom";
import { canViewWalletModule } from "../utils/walletPermissions";

export default function WalletRouteGuard({ children }) {
  if (!canViewWalletModule()) {
    return <Navigate to="/panel/dashboard" replace />;
  }
  return children;
}
